module.exports = __webpack_public_path__ + "img/nvHai1.da78db2c.png";